import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ServicesGrid from './ServicesGrid';
import ClosingCta from './ClosingCta';
import {IconArrowRight} from './Icons';
import {BOOK_URL,STARTING_PRICE} from '../siteConfig';

function ServicesPage() {
  return (
    <div className="site-shell">
      <Header />
      <main>
        <section className="page-hero">
          <span className="kicker">Services</span>
          <h1>Pick what you need. <em>We handle the rest.</em></h1>
          <p>
            Every service is set up, connected and looked after by us. Start with one or two, and add more whenever you are ready. Each starts at ${STARTING_PRICE}/month.
          </p>
          <div className="hero-actions">
            <a className="primary-button" href={BOOK_URL}>Get a custom quote <IconArrowRight /></a>
          </div>
        </section>
        <section className="section" style={{paddingTop: 20}}>
          <ServicesGrid />
        </section>
        <ClosingCta />
      </main>
      <Footer />
    </div>
  );
}

export default ServicesPage;
